import { FreeFortuneThemeDetailSchema } from "@miror/types";
import { Delay } from "components/atoms/Delay";
import { Balloon } from "features/無料占いBot/components/Balloon";
import { Confirmable } from "features/無料占いBot/components/Confirmable";
import { ThemeCards } from "features/無料占いBot/components/ThemeCards";
import { useFormContext } from "react-hook-form";
import { eventName, eventAction, useGaEvent } from "shared/hooks/useGaEvent";
import { FreeFortuneTheme } from "shared/models";

interface Props {
  themes: FreeFortuneTheme[] | FreeFortuneThemeDetailSchema[];
}

const fieldName = "theme";

const SelectTheme = ({ themes }: Props) => {
  const { watch } = useFormContext();

  const themeValue = watch(fieldName);
  const theme = themes?.find((theme) => theme.id.toString() === themeValue);

  const { sendEvent } = useGaEvent();

  const onClickConfirm = () => {
    sendEvent({
      eventName: eventName.freeFortuneChatBot,
      eventAction: eventAction.freeFortuneChatBot.confirmTheme,
      eventParams: {
        theme_id: theme.id.toString(),
      },
    });
  };

  return (
    <Confirmable
      name={fieldName}
      text={`${theme?.name}の鑑定をご希望でお間違いありませんか？`}
      onClickConfirm={onClickConfirm}
    >
      <Delay tw="mb-4">
        <Balloon>
          {`インターネット占い館MIRORへようこそ！🔮\n\nこちらの無料鑑定を最後までご利用頂くと、プロの占い師からの鑑定結果が届きます。\n\n✔️️「相手の本心が知れた」\n✔️「どうすれば上手くいくか分かった！」\n✔️「不安がなくなった！」\n\n多くの方からこのようなお言葉を頂いているので、きっとお力にもなれるはずです。\n\nでは無料鑑定を始めていく前に、\n最適な鑑定をお届けするためにまずは、占いたい内容をお選びください。\n\n無料鑑定はお一人様一度までとさせて頂いておりますので、慎重にお選びください🙇‍♂️⚠️`}
        </Balloon>
        <ThemeCards tw="mt-[30px]" themes={themes} />
      </Delay>
    </Confirmable>
  );
};

export default SelectTheme;
